// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ENFLU7JMMAUM03 {
  padding: var(--ds-space-150, 12px);
  font-weight: var(--ds-font-weight-medium, 500);
  text-align: center;
}
`, ""]);
// Exports
export var emptyState = `ENFLU7JMMAUM03`;
export default ___CSS_LOADER_EXPORT___;
